/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AskMeSenpaiNotificationType {
    ReadQuestions = 0,
    CreateQuestion = 1,
    DeleteQuestion = 2,
    UpdateQuestion = 3,
    ReadCategories = 4,
    CreateCategory = 5,
    DeleteCategory = 6,
    UpdateCategory = 7,
    SetResult = 8,
}
